import {
  Body,
  Button,
  Card,
  CustomLink,
  Flex,
  LazyImage,
  Modal,
  Shape,
  Title,
  styled,
} from '@teko/ds-mobile';
import { YoutubeFrame } from 'components/YoutubeFrame';
import { t } from 'i18n';
import { useState } from 'react';

interface RelatedBlockProps {
  title: string;
  seeMoreUrl?: string;
  items: Array<{ url: string; thumbnailUrl: string; description: string }>;
  type: string;
}

export const MAX_ITEMS_WITH_TWO_BLOCKS = 3;

export const RelatedBlock = (props: RelatedBlockProps) => {
  const { title, seeMoreUrl, items, type } = props;
  const [youtubeLink, setYoutubeLink] = useState<string>();

  const renderItem = (url: string, description: string) => {
    return (
      <Flex align="center" justify="space-between">
        <LazyImage
          height="68px"
          width="120px"
          borderRadius={4}
          contain
          src={url}
        />
        <Shape width="calc(100% - 120px - 16px)">
          <Body level={1} line={3}>
            {description}
          </Body>
        </Shape>
      </Flex>
    );
  };

  return (
    <Card padding="s16" id={`related-${type}`} width="100%">
      <Flex direction="row" justify="space-between" paddingBottom="s16">
        <Title level={3}>{title}</Title>
        {seeMoreUrl && (
          <CustomLink href={seeMoreUrl} target="_blank">
            <Button variant="link">
              <StyledSeeMore>{t('Xem thêm')}</StyledSeeMore>
            </Button>
          </CustomLink>
        )}
      </Flex>
      <Flex direction="column" gap="s16">
        {items.map((item, index) => {
          const { url, thumbnailUrl, description } = item;
          return type === 'post' ? (
            <StyledCustomLink href={url} target="_blank" key={`${index}${url}`}>
              {renderItem(thumbnailUrl, description)}
            </StyledCustomLink>
          ) : (
            <Shape
              onClick={() => setYoutubeLink(url)}
              style={{ cursor: 'pointer', width: '100%' }}
              key={`${index}${url}`}
            >
              {renderItem(thumbnailUrl, description)}
            </Shape>
          );
        })}
      </Flex>
      <Modal
        visible={!!youtubeLink}
        width="960px"
        onClose={() => setYoutubeLink('')}
        showCloseIcon={false}
        footer={false}
        contentStyle={{ padding: '0px' }}
      >
        <IFramePopupWrapper>
          <YoutubeFrame youtubeLink={youtubeLink} />
        </IFramePopupWrapper>
      </Modal>
    </Card>
  );
};

const StyledSeeMore = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: #1b1d29;
`;

const StyledCustomLink = styled(CustomLink)`
  width: 100%;
`;

const IFramePopupWrapper = styled.div`
  width: 100%;
  height: 540px;
  background-color: black;
`;
